import React from 'react';
import { TradingView } from './components/TradingView/TradingView';
import './App.css';
import './fonts.css';

function App() {
  return (
    <div className="App">
      <TradingView />
    </div>
  );
}

export default App;
